module.exports = __webpack_public_path__ + "img/beacon.92d2ef74.svg";